import { TranslateService } from '@ngx-translate/core';

export class MonthCV {

    public list: Array<any>;

    constructor(
        public translateService: TranslateService
    ) {
        this.list = [
            {dayNumber: '01', code: 'january',
                short: translateService.instant('common.month.january.short') as string,      long: translateService.instant('common.month.january.long') as string,    maxDay: 31},
            {dayNumber: '02', code: 'february',
                short: translateService.instant('common.month.february.short') as string,     long: translateService.instant('common.month.february.long') as string,   maxDay: 29},
            {dayNumber: '03', code: 'march',
                short: translateService.instant('common.month.march.short') as string,        long: translateService.instant('common.month.march.long') as string,      maxDay: 31},
            {dayNumber: '04', code: 'april',
                short: translateService.instant('common.month.april.short') as string,        long: translateService.instant('common.month.april.long') as string,      maxDay: 30},
            {dayNumber: '05', code: 'may',
                short: translateService.instant('common.month.may.short') as string,          long: translateService.instant('common.month.may.long') as string,        maxDay: 31},
            {dayNumber: '06', code: 'june',
                short: translateService.instant('common.month.june.short') as string,         long: translateService.instant('common.month.june.long') as string,       maxDay: 30},
            {dayNumber: '07', code: 'july',
                short: translateService.instant('common.month.july.short') as string,         long: translateService.instant('common.month.july.long') as string,       maxDay: 31},
            {dayNumber: '08', code: 'august',
                short: translateService.instant('common.month.august.short') as string,       long: translateService.instant('common.month.august.long') as string,     maxDay: 31},
            {dayNumber: '09', code: 'september',
                short: translateService.instant('common.month.september.short') as string,    long: translateService.instant('common.month.september.long') as string,  maxDay: 30},
            {dayNumber: '10', code: 'october',
                short: translateService.instant('common.month.october.short') as string,      long: translateService.instant('common.month.october.long') as string,    maxDay: 31},
            {dayNumber: '11', code: 'november',
                short: translateService.instant('common.month.november.short') as string,     long: translateService.instant('common.month.november.long') as string,   maxDay: 30},
            {dayNumber: '12', code: 'december',
                short: translateService.instant('common.month.december.short') as string,     long: translateService.instant('common.month.december.long') as string,   maxDay: 31}
        ];
    }

}
